define([
  './inspect_ctrl',
  './json_editor_ctrl',
  './login_ctrl',
  './invited_ctrl',
  './signup_ctrl',
  './reset_password_ctrl',
  './error_ctrl',
], function () {});



//////////////////
// WEBPACK FOOTER
// ./public/app/core/controllers/all.js
// module id = 712
// module chunks = 5